/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_Low_Confidence_LinesInputs */

const en_inbound_field_low_confidence_lines = /** @type {(inputs: Inbound_Field_Low_Confidence_LinesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lines below the threshold`)
};

/**
* | output |
* | --- |
* | "Lines below the threshold" |
*
* @param {Inbound_Field_Low_Confidence_LinesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_low_confidence_lines = /** @type {((inputs?: Inbound_Field_Low_Confidence_LinesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_Low_Confidence_LinesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_low_confidence_lines(inputs)
});